if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productForm = this.productSection.querySelector('product-form');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }

      this.bindAddToCart();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
      if (this.addBtn) this.addBtn.removeEventListener('click', this.boundHandleAddToCart);
    }

    /**
     * Wires the bar's "Add to cart" button to the main product form.
     *
     * Submitting that form rather than posting to /cart/add keeps the cart
     * drawer, header count, error message and on:cart:add event with
     * product-form.js instead of duplicating them here.
     */
    bindAddToCart() {
      this.addBtn = this.querySelector('.js-sticky-atc-add');
      if (!this.addBtn) return;

      this.form = this.productSection.querySelector('.js-product-form-main');
      // Leaving the listener unbound falls back to the anchor's own jump.
      if (!this.form || typeof this.form.requestSubmit !== 'function') return;

      this.boundHandleAddToCart = this.handleAddToCart.bind(this);
      this.addBtn.addEventListener('click', this.boundHandleAddToCart);
    }

    /**
     * Adds the current variant to the cart without moving the page.
     *
     * Returning early leaves the anchor's jump to the form intact, which is the
     * wanted outcome with no variant selected or a disabled submit button.
     * `requestSubmit` fires the submit event; `submit` would bypass listeners.
     */
    handleAddToCart(evt) {
      const variantId = this.form.querySelector('[name="id"]')?.value;
      if (!variantId) return;

      const formSubmitBtn = this.form.querySelector('[name="add"]');
      if (formSubmitBtn?.disabled || formSubmitBtn?.getAttribute('aria-disabled') === 'true') return;

      evt.preventDefault();
      this.form.requestSubmit();
    }

    bindEvents() {
      /**
       * Keyed to the form, not `.product-info`: that wrapper ends ~950px lower
       * (past the description, shipping and payment icons), which on a short
       * product page is beyond the page's own maximum scroll, so the bar could
       * never appear at 1440x900 or 1366x768.
       */
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target !== this.productForm) return;
          this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
        });
      });

      if (this.productForm) observer.observe(this.productForm);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page. The cushion stays under
     * the bar's own height (77px on desktop), or it hides with page still below.
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 40 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
